import { render } from "./DataWidget.vue?vue&type=template&id=34f7118e&scoped=true"
import script from "./DataWidget.vue?vue&type=script&lang=js"
export * from "./DataWidget.vue?vue&type=script&lang=js"

import "./DataWidget.vue?vue&type=style&index=0&id=34f7118e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f7118e"]])

export default __exports__